import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Button, ConfettiTarget, If, Unless } from '../../..'
import SuccessMessage from './SuccessMessage'
import FailureMessage from './FailureMessage'

import styles from './TuneValueComplete.module.scss'

const propTypes = {
  className: PropTypes.string
}

const TuneValueComplete = ({ amount, updated, success, failure, busy, error, onClickBack }) => (
  <div className={classnames(styles.root, !success && !failure && styles.hidden)}>
    <ConfettiTarget className={styles.confetti} go={success && updated} numberOfPieces={150} />
    <If condition={success}>
      <SuccessMessage className={styles.success} amount={amount} />
    </If>
    <If condition={failure}>
      <FailureMessage className={styles.failure} />
    </If>
    <Button fullWidth loading={busy} onClick={onClickBack}>
      <Unless condition={busy}>
        {!!success && !!updated && !error && (
          <FormattedMessage id='TYV.success.button.success' defaultMessage='View updated report' />
        )}
        {(!!failure || !updated || !!error) && (
          <FormattedMessage id='TYV.success.button.failure' defaultMessage='Return to dashboard' />
        )}
      </Unless>
    </Button>
  </div>
)

TuneValueComplete.propTypes = propTypes

export default TuneValueComplete
